const COLLAPSED_HEIGHT = 220;

document.querySelectorAll('[data-collapsible]').forEach((wrap) => {
  const body = wrap.querySelector('[data-collapsible-body]');
  const toggle = wrap.querySelector('[data-collapsible-toggle]');
  if (!body || !toggle) return;

  if (body.scrollHeight <= COLLAPSED_HEIGHT + 24) return;

  body.style.maxHeight = `${COLLAPSED_HEIGHT}px`;
  wrap.classList.add('is-collapsible');
  toggle.hidden = false;

  const moreLabel = toggle.querySelector('[data-label-more]');
  const lessLabel = toggle.querySelector('[data-label-less]');

  toggle.addEventListener('click', () => {
    const expanded = wrap.classList.toggle('is-expanded');
    body.style.maxHeight = expanded ? '' : `${COLLAPSED_HEIGHT}px`;
    toggle.setAttribute('aria-expanded', String(expanded));
    moreLabel.hidden = expanded;
    lessLabel.hidden = !expanded;
  });
});
